import asWorkspaceInfoSheet from '../../components/asWorkspaceInfoSheet.js';
import UrbanihofInfoSheet from './InfoSheet/UrbanihofInfoSheet';

export const InfoSheet = asWorkspaceInfoSheet(UrbanihofInfoSheet);
